import React from 'react';
import './CustomerReport.scss';

const CustomerReport = ({customer}) => {
  console.log(customer);
  return <div>Customer Report</div>;
};

export default CustomerReport;
